import styled from "@emotion/styled";
import { breakpoints, fonts } from "@trustpilot/businessapp-patternlibrary";
import { Button, Typography } from "@trustpilot/constellation-components";

import { zIndexValues } from "../constants";

export const StyledBusinessUserSettings = styled.div({
  margin: "0 0 0 auto",

  [`@media (min-width: ${breakpoints.medium}px)`]: {
    margin: 0,
  },
});

export const BusinessUserContainer = styled.div({
  display: "flex",
  alignItems: "center",
  height: 60,
  [`@media (min-width: ${breakpoints.medium}px)`]: {
    position: "fixed",
    top: 0,
    right: 24,
    zIndex: zIndexValues.z80,
  },
  [`@media (min-width: ${breakpoints.small}px)`]: {
    position: "fixed",
    top: 0,
    right: 24,
    zIndex: zIndexValues.z80,
  },
});

export const IconSpacer = styled.div({
  display: "flex",
  marginRight: "10px",
});

export const NavIcon = styled(Button)({
  //both
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ["> span > span > svg"]: {
    height: "28px !important",
    width: "28px !important",
  },

  // mobile version
  [`@media (max-width: ${breakpoints.small}px)`]: {
    height: "40px !important",
    width: "40px !important",
    minWidth: "40px !important",
    backgroundColor: "#04DA8D",
    ["> span > span > svg"]: {
      fill: "#1C1C1C !important",
      height: "20px !important",
      width: "20px !important",
    },
    borderRadius: "100%",
    ["&:hover"]: {
      backgroundColor: "#05f69f",
      fill: "#1C1C1C !important",
    },

    ["&:active, &:focus"]: {
      border: "3px solid #FFFFFF !important",
      ["> span > span > svg"]: {
        fill: "#1C1C1C !important",
      },
      ["&:hover"]: {
        backgroundColor: "#05f69f",
        ["> span > span > svg"]: {
          fill: "#1C1C1C !important",
        },
      },
    },
  },

  // desktop version
  [`@media (min-width: ${breakpoints.small}px)`]: {
    background: "none !important",
    marginRight: "12px",
    ["> span > span > svg"]: {
      fill: "#1c1c1c !important",
    },
    ["&:hover, &:active"]: {
      ["> span > span > svg"]: {
        fill: "#205cd4 !important",
      },
    },
    ["&:focus"]: {
      border: "1.5px solid #1c1c1c",
      borderRadius: "100%",
      ["> span > span > svg"]: {
        fill: "#1c1c1c !important",
      },
      ["&:hover"]: {
        border: "1.5px solid #205cd4",
        ["> span > span > svg"]: {
          fill: "#205cd4 !important",
        },
      },
    },
  },
});

export const NavHeader = styled.div<{ borderBottom?: boolean }>(({ borderBottom }) => ({
  display: "flex",
  alignItems: "center",
  margin: 0,
  padding: "16px",
  minWidth: "260px",
  borderBottom: borderBottom ? "1px solid #E5E5DD" : "none",
}));

export const NavHeaderTypography = styled(Typography)({
  fontSize: "16px !important",
  fontStyle: "normal !important",
  lineHeight: "120% !important",
  fontWeight: "700 !important",
  letteSpacing: "-0.17px !important",
});

export const NavStyledIcon = styled.div({
  paddingRight: "16px",
  ["> svg"]: {
    width: "20px",
    height: "20px",
  },
});

export const StyledContent = styled.ul({
  padding: "0",
});

export const StyledList = styled.ul<{ borderBottom?: boolean }>(({ borderBottom = false }) => ({
  listStyle: "none",
  margin: "0",
  padding: 16,
  zIndex: zIndexValues.z80,
  whiteSpace: "nowrap",
  borderBottom: borderBottom ? "1px solid #E5E5DD" : "none",
}));

export const StyledListItem = styled.li<{ cursor?: "pointer" | "default" }>(({ cursor = "pointer" }) => ({
  ...fonts["body-1"],
  color: "var(--text-default)",

  marginBottom: 24,

  "&:last-child": {
    marginBottom: 0,
  },

  ".cookie-preferences-link": {
    display: "flex",
  },

  "&:hover": {
    cursor,
  },
}));

const linkStyles = {
  ...fonts["body-2"],
  fontWeight: fonts.weights.normal,
  color: "var(--text-default)",
};

export const StyledLink = styled.a({
  display: "flex",
  alignItems: "center",
  ...linkStyles,
  ":hover": {
    background: "transparent",
    textDecoration: "underline",
    color: "#205cd4 !important",
    border: "none",
  },
  ":focus": {
    padding: 4,
    border: "2px solid #1C1C1C",
    borderRadius: 8,
    outline: 0,
  },
  ":active": {
    background: "transparent",
    textDecoration: "underline",
    color: "#205cd4 !important",
    border: "none",
    padding: 0,
    outline: 0,
  },
});

export const StyledLinkButton = styled.button<{ textAlignLeft?: boolean }>(({ textAlignLeft = false }) => ({
  ...linkStyles,
  textAlign: textAlignLeft ? "left" : "center",
  width: "100%",
  margin: 0,
  padding: 0,
  display: "inline-flex",
  justifyContent: "space-between",
  background: "transparent",
  color: "#1C1C1C !important",
  ":hover": {
    color: "#205cd4 !important",
    borderRadius: 8,
    textDecoration: "underline",
  },
  ":active": {
    borderRadius: 8,
    border: "none !important",
    textDecoration: "underline",
  },
  ":focus": {
    border: "2px solid #1C1C1C",
    borderRadius: 8,
  },
}));
